import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { loadProfileFromIndexedDB } from "../storage/profileStorage";

export default function RedirectPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("collectionToken");

    // Tenta carregar dados do IndexedDB
    loadProfileFromIndexedDB((data) => {
      if (!data || !id) {
        // Não encontrou dados ou id, vai para login
        navigate("/", { replace: true });
        return;
      }

      const { profile, user } = data;

      if (user && profile) {
        navigate(`/dashboard/agenda?collectionToken=${id}`, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    });
  }, [location, navigate]);

  return null;
}
